// Shared search-term handling. This is the client-side half of the rule in
// ZD_Shop_Search_Text (mu-plugins/zd-shop-config): anything that is not a
// letter or a digit separates tokens, and a hit has to contain every token.
// That is what makes `55" portrait`, `55 portrait` and `55-portrait` the same
// query, and what lets a term be found by its name as well as its slug.
//
// The pattern itself is localized from PHP (zd_ajax_object.search), so the
// catalogue filter and the global search cannot drift apart.

var fallback_config = {
    separator_pattern: '[^\\p{L}\\p{N}]+',
    separator_fallback: '[^a-z0-9]+',
    min_length: 2,
};

var separator_regex = null;

function get_config() {
    var localized = (window.zd_ajax_object && window.zd_ajax_object.search) || {};

    return {
        separator_pattern: localized.separator_pattern || fallback_config.separator_pattern,
        separator_fallback: localized.separator_fallback || fallback_config.separator_fallback,
        min_length: parseInt(localized.min_length, 10) || fallback_config.min_length,
    };
}

function get_separator_regex() {
    if (separator_regex) return separator_regex;

    var config = get_config();

    try {
        // Unicode property escapes keep å/ä/ö intact, the same way PCRE's /u does
        separator_regex = new RegExp(config.separator_pattern, 'gu');
    } catch (e) {
        separator_regex = new RegExp(config.separator_fallback, 'g');
    }

    return separator_regex;
}

// Lowercase, separators collapsed to single spaces, trimmed.
export function normalize(value) {
    var text = String(value == null ? '' : value).toLowerCase();

    return text.replace(get_separator_regex(), ' ').trim();
}

// The words a hit has to contain.
export function tokens(value) {
    var normalized = normalize(value);

    return normalized === '' ? [] : normalized.split(' ').filter(Boolean);
}

// A query is only worth running once it says something.
export function is_searchable(value) {
    return normalize(value).replace(/ /g, '').length >= get_config().min_length;
}

// Tokens are matched against the raw text, exactly like the SQL side does.
// A token can never contain a separator, so searching raw text and searching
// normalized text give the identical answer.
export function matches(haystack, search_tokens) {
    if (!search_tokens || !search_tokens.length) return true;

    var text = String(haystack == null ? '' : haystack).toLowerCase();

    return search_tokens.every(function(token) {
        return text.indexOf(token) !== -1;
    });
}
